import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import AssetTypeService from "services/Setup/Organization/assetTypeService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  AssetTypeList: {},
  refreshList: false,
  AssetTypeApprovalList: {},
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
};

export const postAssetType = createAsyncThunk(
  "assetType/postAssetType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AssetTypeService.postAssetType(data);
      console.log("🚀 ~ response:", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          // message.success({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          // message.error({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error:", error);
      // message.error({
      //   status: error,
      //   content: error,
      // });
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getAssetTypeList = createAsyncThunk(
  "assetType/getAssetTypeList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await AssetTypeService.getAssetTypeList(userInput);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getAssetTypeApprovalList = createAsyncThunk(
  "assetType/getAssetTypeApprovalList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await AssetTypeService.getAssetTypeApprovalList(
        userInput
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putAssetTypeApproval = createAsyncThunk(
  "assetType/putAssetTypeApproval",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AssetTypeService.putAssetTypeApproval(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putAssetTypeRequest = createAsyncThunk(
  "assetType/putAssetTypeRequest",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AssetTypeService.putAssetTypeRequest(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          // message: "Error",
          // description: "Unexpected response!",
          message: response.status,
          description: response.statusText,
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getAssetTypeDetail = createAsyncThunk(
  "assetType/getAssetTypeDetail",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AssetTypeService.getAssetTypeDetail(data);
      if (response.status === 200) {
        if (response && response.data) {
          return response;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const updateAssetType = createAsyncThunk(
  "assetType/updateAssetType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AssetTypeService.updateAssetType(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const deleteAssetType = createAsyncThunk(
  "assetType/deleteAssetType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AssetTypeService.deleteAssetType(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const AssetTypeSlice = createSlice({
  name: "assetType",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder

      //post
      .addCase(postAssetType.pending, (state) => {
        state.loading = true;
      })
      .addCase(postAssetType.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload.data.message;
        state.refreshList = true;
      })
      .addCase(postAssetType.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //list
      .addCase(getAssetTypeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getAssetTypeList.fulfilled, (state, action) => {
        state.loading = false;
        state.AssetTypeList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getAssetTypeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //AssetType approval list
      .addCase(getAssetTypeApprovalList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getAssetTypeApprovalList.fulfilled, (state, action) => {
        state.loading = false;
        state.AssetTypeApprovalList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getAssetTypeApprovalList.rejected, (state, action) => {
        state.loading = false;
        state.AssetTypeApprovalList = action.payload;
      })

      //AssetType approval approve
      .addCase(putAssetTypeApproval.pending, (state) => {
        state.loading = true;
        // state.redirect = "";
      })
      .addCase(putAssetTypeApproval.fulfilled, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(putAssetTypeApproval.rejected, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //AssetType approval request
      .addCase(putAssetTypeRequest.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(putAssetTypeRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(putAssetTypeRequest.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //detail
      .addCase(getAssetTypeDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAssetTypeDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(getAssetTypeDetail.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //update
      .addCase(updateAssetType.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateAssetType.fulfilled, (state, action) => {
        state.loading = false;
        // state.redirect = "/";
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(updateAssetType.rejected, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //delete
      .addCase(deleteAssetType.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteAssetType.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(deleteAssetType.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const {
  //    update,
  showNotification,
  hideNotification,
  showLoading,
} = AssetTypeSlice.actions;

export default AssetTypeSlice.reducer;
